<style>
.fit_img {
    width: 100%;
    height: 400px;
}

.five-cols {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
}
</style>
<template>
<v-container>
    <v-row class="text-center">

        <v-col cols="12" class="mt-1" sm="12" lg="12" md="12">
            <div class="account-facebook mt-1">

                <v-avatar :size="40">

                    <img :src="ImagePhoto" />

                </v-avatar>
                <div style="margin-left: 10px;font-weight: bold;">
                    {{ facebook_name }}
                </div>
                <!-- <v-spacer></v-spacer>
                    <v-btn text :disabled="dialogSwitch" color="error" @click="switchAccount()">
                        <v-icon>
                            mdi-account-convert
                        </v-icon>
                    </v-btn> -->

            </div>
            <v-divider class="mt-2"></v-divider>
            <div v-if="isError != true">
                <v-col cols="12" sm="12" md="6" lg="6" class="mt-2">
                    <v-tabs v-model="tab" fixed-tabs>
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab href="#link" class="primary--text">
                            <v-icon>mdi-link</v-icon>&nbsp;
                            Link

                        </v-tab>
                        <v-tab href="#upload" class="primary--text">
                            <v-icon>mdi-video</v-icon>&nbsp;
                            Upload

                        </v-tab>

                    </v-tabs>

                </v-col>
                <v-tabs-items v-model="tab" class="mt-2">
                    <v-tab-item :key="1" value="link">
                        <v-col cols="12" sm="12" md="12" lg="12">
                            <v-text-field v-model="URLlink" label="Link ( Tiktok , Facebook , Youtube , Direct Link )" outlined dense></v-text-field>
                            <v-btn id="btn_login" :loading="LoadingGetVideo" :disabled="LoadingGetVideo" block class="ma-0 red darken-1 white--text font-weight-black " @click="checkExpWithLink()" loading-text="Getting Video">
                                {{ TextProcessLink }}

                            </v-btn>

                        </v-col>

                    </v-tab-item>
                    <v-tab-item :key="2" value="upload">
                        <v-col cols="12" sm="12" md="12" lg="12">
                            <v-file-input v-model="files" color=" accent-4" counter label="Upload Video" multiple placeholder="Select Your Video" prepend-icon="mdi-paperclip" outlined dense :show-size="1000">
                                <template v-slot:selection="{ index, text }">
                                    <v-chip v-if="index < 2" color=" accent-4" dark label small>
                                        {{ text }}
                                    </v-chip>

                                    <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                        +{{ files.length - 2 }} File(s)
                                    </span>
                                </template>
                            </v-file-input>
                            <div v-if="getFileLoading == true" class="mb-3">
                                <v-progress-linear v-model="progress" height="25">
                                    <strong>{{ Math.ceil(progress) }}%</strong>
                                </v-progress-linear>
                            </div>
                            <v-btn id="btn_login" :loading="getFileLoading" :disabled="getFileLoading" block class="ma-0 red darken-1 white--text font-weight-black " @click="checkExpWithUpload()" loading-text="Laden... even geduld aub">
                                Upload
                                <v-icon right dark>
                                    mdi-cloud-upload
                                </v-icon>
                                <template v-slot:loader>
                                    <v-progress-circular :size="20" indeterminate></v-progress-circular> &nbsp;
                                    <span>
                                        {{ loadingUpload }}
                                    </span>
                                </template>
                            </v-btn>
                        </v-col>
                    </v-tab-item>
                </v-tabs-items>
            </div>
            <div v-else class="mt-3">
                <p style="color:red;font-weight:bold">
                    {{ msgError }}
                </p>
            </div>
        </v-col>

    </v-row>
    <v-row v-if="isUploading">
        <v-col col="12">
            <div class="text-center black--text font-weight-black">
                <v-progress-circular size="25" color="black" indeterminate></v-progress-circular>
                &nbsp; {{ loadingUpload }}
            </div>
        </v-col>
    </v-row>
    <div v-if="HidePanelPost">
        <v-row>
            <v-col cols="12" lg="12" sm="12" md="12">
                <v-textarea v-model="caption" outlined name="input-7-4" label="Caption" value="" rows="3" cols="3">
                </v-textarea>

            </v-col>

        </v-row>
        <v-row>
            <v-col cols="12" lg="6" xs="12" sm="12" md="6">
                <v-combobox v-model="selectCTA" :items="items" item-value="value" item-text="label" :return-object="true" label="Select CTA" outlined dense></v-combobox>

            </v-col>
            <v-col cols="12" lg="6" xs="12" sm="12" md="6">

                <v-text-field v-model="CTAtitle" label="Title" placeholder="LIKE PAGE" outlined dense></v-text-field>
            </v-col>

        </v-row>

        <v-row>

            <v-col cols="12" lg="12" xs="12" sm="12" md="12">

                <v-combobox v-model="selectPage" multiple :items="getPages" item-value="id" item-text="name" :return-object="true" label="Select Pages" outlined dense></v-combobox>

            </v-col>

            <v-col cols="12" lg="12" xs="12" sm="12" md="12">
                <!-- <v-btn @click="dialogPost = true" block class="red darken-1 white--text font-weight-black ">
                        Prevew
                    </v-btn> -->
                <div v-if="isTrail == false">
                    <v-btn block id="btn_login" :loading="loadingChangeImage" :disabled="loadingChangeImage" class=" rounded-xl red darken-1 white--text font-weight-black " @click="getRigthSideImage()" loading-text="Posting" style="font-size: 12px;">

                        Choose Image
                        <template v-slot:loader>
                            <v-progress-circular :size="20" indeterminate></v-progress-circular> &nbsp;
                            <span>
                                Loading
                            </span>
                        </template>
                    </v-btn>
                </div>
                <div v-else>
                    <v-btn block id="btn_login" :disabled="isTrail" class=" rounded-xl red darken-1 white--text font-weight-black " @click="getRigthSideImage()" loading-text="Posting" style="font-size: 12px;">

                        Your plan can't choose image

                    </v-btn>
                </div>

            </v-col>
            <v-col cols="12" lg="12" xs="12" sm="12" md="12">
                <!-- <v-btn @click="dialogPost = true" block class="red darken-1 white--text font-weight-black ">
                        Prevew
                    </v-btn> -->
                <v-btn block id="btn_login" :loading="loadingPost" :disabled="loadingPost" class="  rounded-xl  red darken-1 white--text font-weight-black " @click="post()" loading-text="Posting">
                    {{ postText }}

                    <template v-slot:loader>
                        <v-progress-circular :size="20" indeterminate></v-progress-circular> &nbsp;
                        <span>
                            {{ postText }}
                        </span>
                    </template>
                </v-btn>
            </v-col>

        </v-row>

    </div>

    <!-- <v-dialog v-model="dialog"  persistent max-width="500" transition="dialog-bottom-transition" fullscreen> -->
    <v-dialog v-model="dialog" persistent max-width="500">

        <v-card>
            <v-toolbar color="red">
                <v-toolbar-title style="color: white;font-size: 14px">Post Preview</v-toolbar-title>
                <v-spacer>

                </v-spacer>
                <!-- <v-btn color="error" @click="close_post()">
                        <v-icon color="white">
                            mdi-close
                        </v-icon>

                    </v-btn> -->

            </v-toolbar>
            <v-card-text class="text--primary">

                <v-list three-line>
                    <div v-for="(item, index) in selectPage" :key="item.id">

                        <v-divider></v-divider>

                        <v-list-item>
                            <!-- <v-list-item-avatar>
                                    <v-img src="https://cdn.vuetifyjs.com/images/lists/1.jpg"></v-img>
                                </v-list-item-avatar> -->

                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <div v-html="item.status">

                                    </div>

                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-list>
                <v-row class="fill-height" align-content="center" justify="center">

                    <v-col cols="12" v-if="isComplete" style="text-align: center;">

                        <div class="mb-2" style="font-size: 14px;font-weight: bold">
                            {{ prosessingPost }}
                        </div>
                        <!-- <v-progress-circular size="40" :width="5" color="primary" indeterminate>

                            </v-progress-circular> -->
                    </v-col>
                    <v-col v-if="isComplete" style="text-align: center;">
                        <v-btn color="error" @click="close_post()" style="font-size: 12px">

                            <v-icon color="white" size="16">
                                mdi-close
                            </v-icon>
                            Close

                        </v-btn>
                    </v-col>

                </v-row>
            </v-card-text>

        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="red">
                <v-toolbar-title style="color: white;">Choose Image</v-toolbar-title>
                <v-spacer>

                </v-spacer>
                <v-btn color="error" @click="dialogPreview = false">
                    <v-icon color="white">
                        mdi-close
                    </v-icon>

                </v-btn>

            </v-toolbar>

            <v-row class="ma-2">
                <v-col class="d-flex child-flex" cols="4" lg="1">
                    <input type="file" name="uploadimage" accept="image/*" id="uploadimage" ref="uploadimage" hidden @change="uploadToAd">
                    <div v-if="isUploadImagePE == true">
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="black lighten-5"></v-progress-circular>
                        </v-row>

                    </div>
                    <v-img @click='uploadImage()' v-else src="https://www.thecamtool.com/dist/upload.jpeg" lazy-src="https://www.thecamtool.com/dist/upload.jpeg" aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>
                <v-col class="d-flex child-flex" cols="4" lg="1">
                    <v-img @click='getImageRigth("https://www.thecamtool.com/dist/rigth.png")' src="https://www.thecamtool.com/dist/rigth.png" lazy-src="https://www.thecamtool.com/dist/rigth.png" aspect-ratio="1" class="grey lighten-2">
                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </v-col>

                <v-col v-for="(item, index) in ImageRigthSide" :key="index" class="child-flex" cols="4" lg="1">

                    <v-img @click="getImageRigth(item.url)" :src="item.url" :lazy-src="item.url" aspect-ratio="1">

                        <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                        </template>

                    </v-img>
                    <v-btn color="red" block @click="deleteImage(item.hash)" :disabled="item.hash == isDeleteImage">

                        <v-icon color="white" v-if="item.hash != isDeleteImage">
                            mdi-delete
                        </v-icon>
                        <v-progress-circular v-else indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-btn>

                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPost" persistent hide-overlay width="600">

        <v-card>
            <v-card-title class="text-h6 grey lighten-2">
                Preview
            </v-card-title>

            <v-card-text>

                <p class="mt-2">
                    {{ caption }}
                </p>

                <v-row dense>
                    <v-col cols="12">
                        <v-slide-group>
                            <v-slide-item class="ma-1">
                                <v-card color="#eeeeee" elevation="1" max-width="250px">
                                    <v-img :src="selectedThum" height="200px"></v-img>

                                    <v-card-actions>
                                        <v-spacer />
                                        {{ CTAtitle }}
                                        <v-spacer />
                                        <v-spacer />
                                        <v-spacer />
                                        <v-btn color="white">
                                            {{ selectCTA.label }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-item>
                            <v-slide-item class="ma-1">
                                <v-card color="#eeeeee" elevation="1" max-width="250px">
                                    <v-img :src="selectRigthImage" height="200px"></v-img>

                                    <v-card-actions>
                                        <v-spacer />
                                        {{ CTAtitle }}
                                        <v-spacer />
                                        <v-spacer />
                                        <v-spacer />
                                        <v-btn color="white">
                                            {{ selectCTA.label }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>
                        <!-- <v-switch inset></v-switch> -->
                    </v-col>

                </v-row>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>

                <v-spacer></v-spacer>
                <v-btn color="error" @click="dialogPost = false">
                    Close
                </v-btn>
                <v-btn id="btn_login" :loading="loadingPost" :disabled="loadingPost" class="red darken-1 white--text font-weight-black " @click="post()" loading-text="Laden... even geduld aub">
                    {{ postText }}
                    <!-- <v-icon right dark>
                        mdi-cloud-upload
                    </v-icon> -->
                    <template v-slot:loader>
                        <v-progress-circular :size="20" indeterminate></v-progress-circular> &nbsp;
                        <span>
                            {{ postText }}
                        </span>
                    </template>
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialogPreviewVideo" persistent hide-overlay width="500">
        <!-- <v-toolbar  color="">

            Preview
        </v-toolbar> -->
        <v-card title="Preivew Video">

            <div class="">
                <video controls :src="fileURL" style="height: 250px !important;">
                </video>
            </div>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="error" text @click="dialogPreviewVideo = false">
                    Close
                </v-btn>
                <v-btn color="primary" text @click="uploadAdvideo()">
                    Upload
                </v-btn>

            </v-card-actions>
        </v-card>

    </v-dialog>
    <v-dialog v-model="dialogSwitch" transition="dialog-bottom-transition" fullscreen>
        <v-card>
            <v-toolbar color="red">
                <v-toolbar-title style="color: white;font-size: 14px;">Switch Account</v-toolbar-title>
                <v-spacer>

                </v-spacer>
                <v-btn text color="error" @click="dialogSwitch = false">
                    <v-icon color="white">
                        mdi-close
                    </v-icon>

                </v-btn>

            </v-toolbar>

            <v-container>
                <div class="account-facebook mt-2 mb-4" v-for="(item, index) in profileUser" :key="index">

                    <v-avatar :size="40">

                        <img :src="item.image_link" />

                    </v-avatar>
                    <div style="margin-left: 10px;font-weight: bold;">
                        {{ item.facebook_name }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="changeAdccount(item.facebook_id, item.facebook_name, item.access_facebook, item.image_link)">
                        <v-icon>
                            mdi-account-convert
                        </v-icon>
                    </v-btn>

                </div>

            </v-container>

        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogchooseimage" transition="dialog-bottom-transition" fullscreen>
        <v-card>
            <v-toolbar color="red">
                <v-toolbar-title style="color: white;">Choose Image</v-toolbar-title>
                <v-spacer>

                </v-spacer>
                <v-btn color="error" @click="dialogchooseimage = false">
                    <v-icon color="white">
                        mdi-close
                    </v-icon>

                </v-btn>

            </v-toolbar>

            <v-container>
                <v-row>
                    <v-col v-for="n in 9" :key="n" class="d-flex child-flex" cols="4" lg="1">
                        <v-img src="https://www.thecamtool.com/dist/rigth.png" aspect-ratio="1" class="">
                        </v-img>
                    </v-col>
                </v-row>

            </v-container>

        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogChangeAccount" persistent max-width="290">

        <v-card>
            <v-card-title class="red" style="color: white;font-size: 14px">

                Notification

            </v-card-title>

            <v-card-text class="mt-2" style="font-size: 14px;color: black">
                Your Facebook Account Can't Post ! Please Change Your New Account Facebook
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="backtoHome()">
                    Back Home
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAdsAccount" persistent max-width="290">

        <v-card>
            <v-card-title class="red" style="color: white;font-size: 14px">

                Notification

            </v-card-title>

            <v-card-text class="mt-2" style="font-size: 14px;color: black">
                Your Facebook don't have Ads Account
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="backtoHome()">
                    Back Home
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import {
    mdiFormatListBulletedTriangle
} from '@mdi/js';
import axios from 'axios'

export default {
    name: 'Video-PE',

    data: () => ({
        isTrail: false,
        imageFreeTrail: "https://camfeed.net/image/logo_pe.jpg",
        dialogAdsAccount: false,
        isDeleteImage: "",
        dialogChangeAccount: false,
        loadingChangeImage: false,
        dialogchooseimage: false,
        page_selectpost: 0,
        dialogSwitch: false,
        userData: '',
        isUploading: false,
        loadingUpload: "Loading",
        dialogPreviewVideo: false,
        LoadingGetVideo: false,
        TextProcessLink: 'Get Video',
        overlay: false,
        dialogFacebook: false,
        dialogPreview: false,
        dialog: false,
        dialogPost: false,
        getFileLoading: false,
        HidePanelPost: false,
        loadingPost: false,
        isComplete: true,
        files: [],
        tab: "subscribe",
        postText: 'post',
        fileURL: '',
        URLlink: '',
        selectCTA: {
            value: 'LIKE_PAGE',
            label: 'Like Page'
        },
        caption: '',

        typeUpload: 'upload',

        items: [{
            value: 'LIKE_PAGE',
            label: 'Like Page'
        }, {
            value: 'LEARN_MORE',
            label: 'Learn More'
        }, {
            value: 'WATCH_MORE',
            label: 'Watch More'
        }],
        graph_version: 'v20.0',
        accessToken: '',
        adsSelected: '',
        id_facebook: '',
        facebook_name: 'Loading',
        ImagePhoto: 'https://www.thecamtool.com/dist/image_logo.png',
        selectedThum: '',
        selectRigthImage: 'https://camfeed.net/image/logo_pe.jpg',
        video_id: '',
        getPages: [],
        selectPage: [],
        check_statement: 0,
        CTAtitle: 'LIKE MY PAGE',
        ImageRigthSide: [],
        TextProcessUpload: 'UPLOAD',
        soureFacebookVideo: [],
        progress: 0,
        prosessingPost: 'Loading',
        showMsg: '',
        profileUser: [],
        isError: false,
        msgError: "",
        imageRigthSideURL: "",
        isUploadImagePE: false

    }),
    methods: {

        //    changeImages(){
        //      this.ImageRigthSide = 

        //    }, 

        backtoHome() {

            this.$router.push('dashboard').catch(err => {})
        },

        showError() {

            return "Posting";

        },
        switchAccount() {

            this.dialogSwitch = true
            axios.get('https://v2.thecamtool.com/user/useraccesstoken/' + this.userData.data.user.id).then((data) => {
                if (data.data.data.status == 0) {
                    this.profileUser = data.data.data.access_token

                }

            }).catch((err) => {

            }).finally(() => {

                this.dialogSwitch = true

            })

        },
        changeAdccount(id_facebook, facebook_name, access_token, img_link) {

            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + id_facebook + '/adaccounts', {

                params: {
                    access_token: access_token,
                    fields: "id,account_id,name,account_status"
                }

            }).then((data) => {

                if (data.data.data.length == 1) {
                    console.log(data.data)
                    this.adsSelected = data.data.data[0].id
                    // this.adsSelected = item.id

                } else {

                    data.data.data.forEach((item) => {

                        if (item.account_status == 2 || item.account_status != 1) {

                            //this.$swal('warning', "Please change your account fb ", 'error');

                            //return 0;
                            this.adsSelected = ''

                        } else {

                            this.adsSelected = item.id
                        }

                    })

                }

            }).catch((data) => {

                this.$swal('Error', this.errorMSG(data), 'error');

            }).finally((data) => {

                this.ImagePhoto = img_link
                this.facebook_name = facebook_name
                this.accessToken = access_token
                this.id_facebook = id_facebook
                this.dialogSwitch = false
                //  console.log(this.ImagePhoto)
            })

        },
        openView(url) {

            window.open(url)
        },
        deleteImage(h) {
            var $t = this
            $t.isDeleteImage = h
            $.ajax({
                type: "DELETE",
                url: 'https://graph.facebook.com/v18.0/' + this.adsSelected + '/adimages',
                data: {
                    hash: h,
                    access_token: this.accessToken
                }
            }).then(function (data) {
                $t.isDeleteImage = ""
                $t.getRigthSideImage()
            }, function (data) {
                $t.isDeleteImage = ""
                $t.getRigthSideImage()
            })

        },
        uploadToAd(event) {

            const files = event.target.files;
            let filename = files[0].name;
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.imageRigthSideURL = fileReader.result
            })

            fileReader.readAsDataURL(files[0])
            this.imageRigthSideURL = files[0]
            this.uploadToFacebook()

        },

        uploadToFacebook() {
            this.isUploadImagePE = true
            var bodyFormData = new FormData();
            bodyFormData.append("filename", this.imageRigthSideURL)
            bodyFormData.append("access_token", this.accessToken)
            axios.post(
                'https://graph.facebook.com/' + this.adsSelected + '/adimages', bodyFormData
            ).then((data) => {

                this.getRigthSideImage()
                this.isUploadImagePE = false
            }).catch((err) => {
                this.getRigthSideImage()
            }).finally((err) => {
                // this.getRigthSideImage()
                this.isUploadImagePE = false
            })

        },
        uploadImage() {

            this.$refs.uploadimage.click();

            // console.log(1)
        },
        getImageRigth(url) {

            this.dialogPreview = false
            this.selectRigthImage = url

        },
        getVideoLink() {

            if (this.URLlink == "") {
                this.$swal('Opps..!', "Please enter your link video !", 'warning');
                return;

            }
            this.TextProcessLink = "Geting Video.."
            if (this.URLlink.includes('facebook.com') || this.URLlink.includes('youtube.com') || this.URLlink.includes('tiktok.com')) {
                this.LoadingGetVideo = true
                var url = this.URLlink;
                var bodyFormData = new FormData();
                bodyFormData.append("url", url)
                axios.post(
                    'https://camsmartbiz.com/apicamtool.php', bodyFormData
                ).then((data) => {

                    if (data.data.data.staus == true) {
                        this.dialogPreviewVideo = true
                        this.fileURL = data.data.data.source[0]
                        this.TextProcessLink = "Get video"
                        this.LoadingGetVideo = false
                        //   this.videoUploadToFB(this.fileURL)
                    } else {
                        this.URLlink = ""
                        this.$swal('Opps..!', data.data.data.message, 'error');
                    }

                }).catch((err) => {
                    this.URLlink = ""
                    this.TextProcessLink = "Get video"
                    this.LoadingGetVideo = false
                    this.$swal('Opps..!', "Something Wrong !", 'error');
                }).finally((err) => {
                    this.URLlink = ""
                    this.TextProcessLink = "Get video"
                    this.LoadingGetVideo = false

                })
            } else {

                this.dialogPreviewVideo = true
                this.fileURL = this.URLlink
                this.TextProcessLink = "Get video"
                this.LoadingGetVideo = false

            }

        },

        uploadAdvideo() {
            this.isUploading = true
            this.loadingUpload = "Uploading"
            this.dialogPreviewVideo = false
            var bodyFormData = new FormData();
            bodyFormData.append('access_token', this.accessToken)
            bodyFormData.append('file_url', this.fileURL)
            axios.post('https://graph.facebook.com/' + this.graph_version + '/' + this.adsSelected + '/advideos', bodyFormData).then((data) => {

                this.video_id = data.data.id

                this.loadingUpload = "Processing"

                setTimeout(() => {

                    this.getThumbnail();

                }, 2000);

            }).catch((data) => {

                this.loadingUpload = ""
                this.isUploading = false
                this.$toast.error(this.errorMSG(data), {
                    // toast opitons here
                    position: 'bottom-right',
                });

            })
        },
        getProfileFacebok() {

            axios.get('https://graph.facebook.com/me', {

                    params: {

                        access_token: this.accessToken

                    }
                }

            ).then((data) => {

                var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");
                if (hasPropertyError) {

                    this.$swal('Profile', this.errorMSG(data), 'error');

                } else {
                    console.log(data)

                    this.id_facebook = data.data.id;

                    this.facebook_name = data.data.name

                    var urlimage = "https://graph.facebook.com/" + this.id_facebook + "/picture?height=500&access_token=6628568379%7Cc1e620fa708a1d5696fb991c1bde5662";

                    this.ImagePhoto = urlimage;

                    //  this.getAdsAccont()

                }

            }).catch((data) => {

                //    window.location.href = ''
                this.overlay = true

            }).finally((data) => {
                // window.location.href = ''
                this.getFileLoading = false
                this.overlay = false

            })

        },

        getRigthSideImage() {

            this.loadingChangeImage = true;
            axios.get('https://graph.facebook.com/' + this.adsSelected + '/adimages', {
                params: {
                    access_token: this.accessToken,
                    fields: "id,url,hash"
                }
            }).then((data) => {
                this.dialogPreview = true
                this.loadingChangeImage = false
                this.ImageRigthSide = data.data.data
                console.log(this.ImageRigthSide)
            }).catch(() => {
                this.loadingChangeImage = false
                this.$swal('Request', 'Request error', 'error');
            })

        },
        getAdsAccont() {

            // for get ads account

            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + this.id_facebook + '/adaccounts', {

                params: {
                    access_token: this.accessToken,
                    fields: "id,account_id,name,account_status"
                }

            }).then((data) => {

                if (data.data.data.length == 1) {

                    if (data.data.data[0].account_status == 2 || data.data.data[0].account_status != 1) {

                        this.isError = true
                        this.dialogChangeAccount = true
                    } else {
                        this.adsSelected = data.data.data[0].id
                    }

                    // this.adsSelected = item.id

                } else {

                    if (data.data.data.length > 0) {
                        data.data.data.forEach((item) => {

                            if (item.account_status == 2 || item.account_status != 1) {

                                this.isError = true
                                this.dialogChangeAccount = true
                                //return 0;

                            } else {

                                this.adsSelected = item.id
                            }

                        })
                    } else {

                        this.isError = true
                        this.dialogAdsAccount = true

                    }

                }

            }).catch((data) => {

                // this.$swal('Error', this.errorMSG(data), 'error');    
                this.isError = true
                this.msgError = this.errorMSG(data)

            })

        },

        getThumbnail() {
            this.loadingUpload = "Getting Thumbnail"
            axios.get("https://graph.facebook.com/" + this.video_id,

                {
                    params: {
                        access_token: this.accessToken,
                        fields: "thumbnails,picture,length",
                    }

                }).then((data) => {

                var hasPropertyThum = Object.prototype.hasOwnProperty.call(data.data, "thumbnails");
                if (hasPropertyThum && data.data.thumbnails.data.length > 2) {

                    this.selectedThum = data.data.thumbnails.data[3].uri
                    this.isUploading = false
                    this.getFileLoading = false
                    this.HidePanelPost = true
                    this.TextProcessUpload = "UPLOAD"
                    this.getPagesData()

                } else {

                    setTimeout(() => {
                        this.getThumbnail();
                    }, 2000);

                }

            }).catch((data) => {
                this.isUploading = false
                this.errorPost();
                this.$swal('Error', this.errorMSG(data), 'error');
            })

        },
        getPagesData() {

            //for get pages

            axios.get('https://graph.facebook.com/' + this.id_facebook + '/accounts',

                {
                    params: {
                        access_token: this.accessToken,
                        limit: 100,
                        fields: "id,name,access_token"
                    }

                }).then((data) => {

                var obj = []

                data.data.data.forEach((item, index) => {

                    obj.push({
                        name: item.name,
                        id: item.id,
                        access_token: item.access_token,
                        status: ''

                    })

                });

                this.getPages = obj

            }).catch((data) => {
                this.$swal('Error', this.errorMSG(data), 'error');

            })

        },

        uploadVideoAd() {

            if (this.files == '') {

                this.$swal('Upload', 'Select your video', 'warning')

            } else {

                this.getFileLoading = true
                //  this.TextProcessUpload = "Uploading"
                var bodyFormData = new FormData();
                bodyFormData.append('file', this.files[0])

                axios.post('https://camsmartbiz.com/upload.php', bodyFormData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function (progressEvent) {

                            this.progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }.bind(this)
                    }

                ).then((data) => {

                    //  this.TextProcessUpload = "Processing..."
                    this.fileURL = data.data.url
                    this.getFileLoading = false
                    this.uploadAdvideo()

                }).catch((data) => {

                    this.getFileLoading = false

                    this.$toast.error("Someting Wrong !", {
                        // toast opitons here
                        position: 'bottom-right',
                    });

                })

            }

        },

        post() {

            if (this.selectPage.length > 0) {

                if (this.check_statement < this.selectPage.length) {
                    this.statusError = []
                    this.loadingPost = true
                    this.isComplete = true
                    var data_count = this.check_statement + 1;
                    this.showMsg = ""
                    this.postText = "Posting" + data_count + " of pages " + this.selectPage.length;
                    this.prosessingPost = "Posting " + data_count + " of pages " + this.selectPage.length;

                    var cta_value = {}

                    if (this.selectCTA.value == "LIKE_PAGE") {
                        cta_value["page"] = this.selectPage[this.check_statement].id;

                    } else {

                        cta_value["link"] = "https://web.facebook.com/" + this.selectPage[this.check_statement].id

                    }

                    if (this.CTAtitle == '') {
                        this.CTAtitle = this.selectPage[this.check_statement].name
                    }
                    var cta = {
                        type: this.selectCTA.value,
                        value: cta_value
                    }

                    var data_post = {

                        name: moment(moment(), "DD MMM YYYY hh:mm A").format("X"),
                        object_story_spec: {
                            page_id: this.selectPage[this.check_statement].id,
                            link_data: {

                                message: this.caption,
                                caption: "https://web.facebook.com/" + this.selectPage[this.check_statement].id,
                                link: "https://web.facebook.com/" + this.selectPage[this.check_statement].id,
                                multi_share_optimized: false,
                                child_attachments: [{
                                        name: this.CTAtitle,
                                        link: "https://web.facebook.com/" + this.selectPage[this.check_statement].id,
                                        video_id: this.video_id,
                                        picture: this.selectedThum,
                                        call_to_action: cta
                                    },
                                    {
                                        name: this.CTAtitle,
                                        link: "https://web.facebook.com/" + this.selectPage[this.check_statement].id,
                                        picture: this.selectRigthImage,
                                        call_to_action: cta
                                    }
                                ]

                            }

                        },
                        access_token: this.accessToken

                    }
                    this.dialog = true
                    this.dialogPost = false
                    var html = '<span style="color:green;font-size:16px">Posting</span>'
                    this.selectPage[this.check_statement].status = html
                    this.page_selectpost = this.selectPage[this.check_statement].id
                    axios.post('https://graph.facebook.com/' + this.graph_version + '/' + this.adsSelected + '/adcreatives', data_post).then((data) => {

                        var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");

                        if (hasPropertyError) {

                            this.$toast.error(this.errorMSG(data), {
                                // toast opitons here
                                position: 'bottom-right',
                            });

                        } else {

                            var hasId = Object.prototype.hasOwnProperty.call(data.data, "id");
                            var html = '<span style="color:green;font-size:16px">Getting ID</span>'
                            this.selectPage[this.check_statement].status = html
                            if (hasId) {

                                axios.get('https://graph.facebook.com/' + this.graph_version + '/' + data.data.id, {
                                        params: {
                                            access_token: this.accessToken,
                                            fields: 'effective_object_story_id'
                                        }
                                    }

                                ).then((effect) => {

                                    var haseffect = Object.prototype.hasOwnProperty.call(effect, "effective_object_story_id");

                                    if (haseffect) {
                                        var html = '<span style="color:green;font-size:16px">Publishing</span>'
                                        this.selectPage[this.check_statement].status = html

                                        var d = {

                                            access_token: this.selectPage[this.check_statement].access_token,
                                            is_published: true
                                        }

                                        axios.post('https://graph.facebook.com/' + this.graph_version + '/' + effect.effective_object_story_id, d)

                                            .then((data) => {

                                                var hasError = Object.prototype.hasOwnProperty.call(data.data, "error")

                                                if (hasError) {

                                                    var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                                                    this.selectPage[this.check_statement].status = html

                                                    this.check_statement++

                                                    this.post()

                                                } else {

                                                    this.statusError.push({
                                                        name: this.selectPage[this.check_statement].name,
                                                        id: this.selectPage[this.check_statement].id,
                                                        error: 'https://www.facebook.com/' + effect.data.effective_object_story_id,
                                                        statusCode: false

                                                    })

                                                    var html = '<span style="color:green;font-size:16px">Posted</span>'
                                                    this.selectPage[this.check_statement].status = html

                                                    this.check_statement++

                                                    this.post()

                                                }

                                            }).catch((data) => {
                                                var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                                                this.selectPage[this.check_statement].status = html
                                                this.loadingPost = false

                                                this.check_statement++

                                                this.post()

                                            })

                                    } else {

                                        setTimeout(() => {
                                            this.try_to_publish(data.data.id)
                                        }, 5000);

                                    }

                                }).catch((data) => {
                                    //  this.loadingPost = false
                                    this.check_statement++

                                    var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                                    this.selectPage[this.check_statement].status = html

                                    this.post()

                                })

                            } else {
                                this.loadingPost = false

                            }

                        }

                    }).catch((data) => {

                        this.loadingPost = false
                        var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                        this.selectPage[this.check_statement].status = html
                        this.check_statement++
                        this.post()

                    })

                } else {

                    this.done_post()
                }

            } else {

                this.$swal('Page', 'Please select your page', 'warning')

            }

        },

        try_to_publish(id_adtive) {

            var html = '<span style="color:green;font-size:16px">Getting ID</span>'
            this.selectPage[this.check_statement].status = html
            axios.get('https://graph.facebook.com/' + this.graph_version + '/' + id_adtive, {
                    params: {
                        access_token: this.accessToken,
                        fields: 'effective_object_story_id'
                    }
                }

            ).then((effect) => {

                var haseffect = Object.prototype.hasOwnProperty.call(effect.data, "effective_object_story_id");
                if (haseffect) {
                    var html = '<span style="color:green;font-size:16px">Publishing</span>'
                    this.selectPage[this.check_statement].status = html
                    var d = {

                        access_token: this.selectPage[this.check_statement].access_token,
                        is_published: true
                    }

                    axios.post('https://graph.facebook.com/' + this.graph_version + '/' + effect.data.effective_object_story_id, d)
                        .then((data) => {

                            var link_view = "https://www.facebook.com/" + effect.data.effective_object_story_id;
                            var html = '<span style="color:green;font-size:16px"><a href="' + link_view + '" target="_blank" style="text-decoration:none">View Posted</a></span>'
                            this.selectPage[this.check_statement].status = html

                            this.check_statement++
                            this.post()

                        }).catch((data) => {

                            var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                            this.selectPage[this.check_statement].status = html
                            this.check_statement++

                            this.post()

                        })

                } else {

                    setTimeout(() => {
                        this.try_to_publish(id_adtive)
                    }, 5000);

                }

            }).catch((data) => {

                var html = '<span style="color:red;font-size:16px">' + this.errorMSG(data) + '</span>'
                this.selectPage[this.check_statement].status = html
                this.check_statement++

                this.post()

            })

        },

        errorPost() {
            this.URLlink = '';
            this.TextProcessUpload = "Upload"
            this.getFileLoading = false

        },

        errorMSG(data) {
            var msgTitle = "";
            var msgDesc = "";

            if (data.hasOwnProperty("response")) {
                if (data.response.data.error.hasOwnProperty("error_user_title")) {
                    msgTitle = data.response.data.error.error_user_title;

                    msgDesc = data.response.data.error.error_user_msg.replace(/"/g, "'");
                } else {
                    msgTitle = data.response.data.error.type;

                    msgDesc = data.response.data.error.message;
                }
            } else {
                msgTitle = "No Internet";
                msgDesc = "Please check your internet connection";
            }

            return msgDesc
        },

        done_post() {
            this.HidePanelPost = false
            this.dialog = true;
            // this.selectPage = []
            this.check_statement = 0
            this.loadingPost = false
            this.postText = 'post';
            this.prosessingPost = 'All Complete';
            // this.isComplete = false;
            this.showMsg = ''
            this.files = []

        },

        close_post() {
            this.HidePanelPost = false
            this.dialog = false;
            this.selectPage = []
            this.check_statement = 0
            this.loadingPost = false
            this.postText = 'post';
            this.prosessingPost = 'All Complete';
            this.isComplete = false;
            this.showMsg = ''
            this.files = []

        },

        checkExpUser() {
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {

                    this.$router.push('expired').catch(err => {})

                } else {
                    this.getProfileWithADS()
                }

            }).catch((err) => {
                this.$swal('Error', "Something Wrong !", 'error');

            }).finally(() => {

            })
        },

        checkExpWithUpload() {
            if (this.files == '') {

                this.$swal('Upload', 'Select your video', 'warning')

            } else {
                this.getFileLoading = true
                axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                    if (data.data.data.expired == true) {
                        this.URLlink = ""
                        // this.$swal('Error', "Your Account Has Expired Please Upgrade the plan !", 'warning');
                        this.$router.push('expired').catch(err => {})
                        this.getFileLoading = false

                    } else {
                        if (data.data.data.plan == 0) {
                            this.isTrail = true
                        } else {
                            this.isTrail = false
                        }
                        this.uploadVideoAd()

                    }

                }).catch((err) => {
                    this.$swal('Error', "Something Wrong !", 'error');
                }).finally(() => {

                })
            }

        },
        checkExpWithLink() {
            if (this.URLlink == "") {
                this.$swal('Opps..!', "Please enter your link video !", 'warning');
                return;

            }
            this.TextProcessLink = "Checking"
            this.LoadingGetVideo = true
            axios.get('https://app.camsmartbiz.com/user/checkexp/' + this.userData.data.user.id).then((data) => {

                if (data.data.data.expired == true) {
                    this.URLlink = ""
                    // this.$swal('Error', "Your Account Has Expired Please Upgrade the plan !", 'warning');
                    this.$router.push('expired').catch(err => {})
                    this.LoadingGetVideo = false
                    this.TextProcessLink = "Get Video"

                } else {

                    if (data.data.data.plan == 0) {
                        this.isTrail = true
                    } else {
                        this.isTrail = false
                    }
                    this.getVideoLink()
                }

            }).catch((err) => {
                this.$swal('Error', "Something Wrong !", 'error');
            }).finally(() => {

            })

        },
        getAccessToken() {
            this.overlay = true
            axios.get('https://app.camsmartbiz.com/user/useraccesstoken/' + this.userData.data.user.id).then((data) => {
                if (data.data.data.status == 0) {
                    this.ImagePhoto = data.data.data.access_token[0].image_link
                    this.facebook_name = data.data.data.access_token[0].facebook_name
                    this.accessToken = data.data.data.access_token[0].access_facebook
                    this.id_facebook = data.data.data.access_token[0].facebook_id
                    this.getAdsAccont()

                } else {

                }

            }).catch((err) => {
                this.$swal('Error', "Something Wrong !", 'error');
            }).finally(() => {

                this.overlay = false

            })

        },

        getProfileWithADS() {

            this.overlay = true
            axios.get('https://graph.facebook.com/me', {

                    params: {

                        access_token: this.accessToken

                    }
                }

            ).then((data) => {

                var hasPropertyError = Object.prototype.hasOwnProperty.call(data.data, "error");
                if (hasPropertyError) {

                    this.$swal('Profile', this.errorMSG(data), 'error');

                } else {
                    // console.log(data)

                    this.id_facebook = data.data.id;

                    this.facebook_name = data.data.name

                    var urlimage = "https://graph.facebook.com/" + this.id_facebook + "/picture?height=500&access_token=6628568379%7Cc1e620fa708a1d5696fb991c1bde5662";

                    this.ImagePhoto = urlimage;

                    this.getAdsAccont()

                }

            }).catch((data) => {
                this.$swal('Profile', this.errorMSG(data), 'error');
                this.overlay = true
                this.$router.push('dashboard')

            }).finally((data) => {
                this.getFileLoading = false
                this.overlay = false

            })

        },

    },

    mounted() {

        // this.getAccessToken()
        // this.getProfileWithADS()

        this.checkExpUser()

    },

    created() {

        this.userData = JSON.parse(localStorage.getItem('info'))
        this.accessToken = localStorage.getItem('accessToken');

    }
}
</script>
<style>
.account-facebook {

    display: flex;
    text-align: center;
    vertical-align: middle;
    flex-direction: row;
    align-content: space-between;
    align-items: center;

}

video {
    width: 100% !important;
    height: 150px !important;
}

.swal2-popup {
    font-size: 12px !important;
}

.v-dialog {
    /* border: 1px solid rgb(27, 134, 227); */
    border-radius: 10px;
}
</style>
